import React, { useRef } from "react";
import styles from './DocumentProcessor.module.css';

export default function ExcelInputPanel({
    selectedFile,
    setSelectedFile,
    setFileName,
}) {
    const inputRef = useRef(null);

    const onFile = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setSelectedFile(file);
        setFileName(file.name.replace(/\.[^/.]+$/, ""));
    };

    return (
        <>
            <h3>Выберите Excel файл:</h3>
            <div className={styles.filePicker}>
                <input
                    ref={inputRef}
                    type="file"
                    accept=".xlsx,.xls"
                    className={styles.fileInput}
                    onChange={onFile}
                />
                <button
                    type="button"
                    className={`${styles.btn} ${styles.filePickerButton}`}
                    onClick={() => inputRef.current?.click()}
                >
                    Выберите файл
                </button>
            </div>
            {selectedFile && (
                <div className={styles.fileSelectedLabel}>
                    Выбран файл: {selectedFile.name}
                </div>
            )}
        </>
    );
}
